<script lang="ts">
  import { createSource, ISrcSetData } from '@centerhealth/fe/images';
  import { ReviewTypes } from '@centerhealth/fe/center-kit';

  // Center Image propeties for social sprite
  const imageSocial: ISrcSetData = {
    sourceUrl: '/assets/sprites/social-sprite.webp',
  };

  // quote, instagram, facebook, twitter, snapchat
  export let reviewType: ReviewTypes = 'quote';

  // Review's image, an image file path inside "public/assets"
  export let image: string;

  // Center Image propeties for review
  const imageReview: ISrcSetData = {
    sourceUrl: '/' + image,
  };
</script>

{#if reviewType}
  <div class="review-type absolute top-8 right-8 w-8 h-8 overflow-hidden {reviewType}">
    <img
      width="64"
      height="64"
      src={createSource(imageSocial.sourceUrl)}
      alt="{reviewType} Review"
      class="h-auto opacity-20"
    />
  </div>
{/if}

<img
  loading="lazy"
  width="100"
  height="100"
  src={createSource(imageReview.sourceUrl)}
  class="card-image rounded-t-2xl w-full"
  alt="Review"
/>

<style>
  /** social icon positioning and styling based on reviewType **/
  .review-type img {
    max-width: 64px;
  }
  .review-type.facebook img {
    margin-top: -34px;
  }
  .review-type.twitter img {
    margin-top: -68px;
  }
  .review-type.snapchat img {
    margin-top: -102px;
  }
</style>
